import { accessTypeEnum } from '../../../lib/enum';
import type { UserAccess } from '../../../lib/types';

const legacyAccessTypeEnum = accessTypeEnum as Record<string, string | undefined>;

export const addAccessRight = [
  accessTypeEnum.admin,
  accessTypeEnum.adminBranch,
  legacyAccessTypeEnum.handlingBudgetAnalysis
];

export const canAdd = (userAccess: UserAccess[]) =>
  userAccess.some(access => addAccessRight.includes(access));

export default {
  addAccessRight,
  canAdd
};
